import { render, staticRenderFns } from "./TextareaInput.vue?vue&type=template&id=9b0f00ac&scoped=true"
import script from "./TextareaInput.vue?vue&type=script&lang=js"
export * from "./TextareaInput.vue?vue&type=script&lang=js"
import style0 from "./TextareaInput.vue?vue&type=style&index=0&id=9b0f00ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0f00ac",
  null
  
)

export default component.exports